export default "__VITE_ASSET__034cc347__"